import React, { useMemo, useState } from 'react';
import cx from 'classnames';

import { Label } from '@atlas/ui';

import { sportService } from 'common/constants';
import eventShape from 'common/PropTypes/eventShape';

import Scoreboard from './Scoreboard/Scoreboard';
import Tracker from './Tracker/Tracker';

const { ARCHIVED, PREMATCH } = sportService;

const GameStats = ({ event }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { externalId, sportService } = event;

  const tabs = useMemo(
    () =>
      [
        !(event.outright && sportService === ARCHIVED) && {
          component: <Scoreboard event={event} />,
          tabName: 'Score Frame',
        },
        externalId &&
          sportService !== ARCHIVED && {
            component: <Tracker event={event} id={externalId} />,
            tabName: 'Live Tracker',
          },
      ].filter(Boolean),
    [event, externalId, sportService],
  );

  const activeComponent = useMemo(
    () => tabs[activeTabIndex]?.component || null,
    [tabs, activeTabIndex],
  );

  if ([PREMATCH].includes(sportService)) {
    return null;
  }

  if (tabs.length === 1) {
    return activeComponent;
  }

  return (
    <div className="tracker-container">
      <div className="tabs-bar">
        <div className="tabs-list">
          {tabs.map(({ tabName }, index) => {
            const className = cx('tab-list-item', activeTabIndex === index && ' active');
            const onClick = () => setActiveTabIndex(index);

            return (
              <a className={className} key={tabName} onClick={onClick}>
                <Label message={tabName} />
              </a>
            );
          })}
        </div>
      </div>
      {activeComponent}
    </div>
  );
};

GameStats.propTypes = { event: eventShape };

export default GameStats;
